export default __webpack_public_path__ + "static/media/focusIcon.a79354c2.svg";